import axios from 'axios';
import { getApiConfig, getApiHeaders, removeApiAuthToken } from './api-helper';
import { JSON_ENCODED, FORM_ENCODED } from '../constants/apiContentTypes';

const addInterceptor = (instance) => {
  // https://axios-http.com/docs/interceptors
  instance.interceptors.response.use(({
    config: { params }, data, headers, status, statusText,
  }) =>
    /**
     * no need to return request. config, just send along params
     * https://axios-http.com/docs/res_schema
     */
    // eslint-disable-next-line implicit-arrow-linebreak
    ({
      config: { params }, data, headers, status, statusText,
    }),
  (error) => {
    if (error.response?.status === 419 && window.apiAuthToken) {
      removeApiAuthToken();
      window.location.reload();
    }

    return error.response;
  });

  return instance;
};

const getAxios = (config) => addInterceptor(axios.create(config));

const getAxiosConfig = (baseURL = getApiConfig('Config').baseUrl, headers = getApiHeaders(), withCredentials) => ({
  baseURL,
  headers,
  timeout: 20000,
  withCredentials,
});

// services
export const resyApiGetLegacy = ({ authToken, withCredentials } = {}) => getAxios(
  getAxiosConfig(
    getApiConfig('Config').baseRequestUrl,
    getApiHeaders({ authToken }),
    withCredentials
  )
);

export const resyApiPostLegacy = ({ authToken, contentType = FORM_ENCODED, withCredentials } = {}) => getAxios(
  getAxiosConfig(
    getApiConfig('Config').baseRequestUrl,
    getApiHeaders({ authToken, contentType }),
    withCredentials
  )
);

export const resyApiPatchLegacy = ({ authToken, contentType = FORM_ENCODED } = {}) => getAxios(
  getAxiosConfig(
    getApiConfig('Config').baseRequestUrl,
    getApiHeaders({ authToken, contentType })
  )
);

export const resyApiDeleteLegacy = ({ authToken, contentType = FORM_ENCODED } = {}) => getAxios(
  getAxiosConfig(
    getApiConfig('Config').baseRequestUrl,
    getApiHeaders({ authToken, contentType })
  )
);

export const ipdataLegacy = () => getAxios(
  getAxiosConfig(
    getApiConfig('IpdataConfig').baseRequestUrl,
    { 'Cache-Control': 'no-cache' }
  )
);

export const itemsGetLegacy = () => getAxios(
  getAxiosConfig(
    getApiConfig('ItemsServiceConfig').baseRequestUrl,
    getApiHeaders()
  )
);

export const annotationGetLegacy = () => getAxios(
  getAxiosConfig(
    getApiConfig('AnnotationServiceConfig').baseRequestUrl,
    getApiHeaders()
  )
);

export const resyOsGetLegacy = () => getAxios(
  getAxiosConfig(
    getApiConfig('ResyosServiceConfig').baseRequestUrl
  )
);

export const resyOsPostLegacy = ({ contentType = JSON_ENCODED } = {}) => getAxios(
  getAxiosConfig(
    getApiConfig('ResyosServiceConfig').baseRequestUrl,
    getApiHeaders({ contentType })
  )
);

export const resyOsDeleteLegacy = ({ contentType = JSON_ENCODED } = {}) => getAxios(
  getAxiosConfig(
    getApiConfig('ResyosServiceConfig').baseRequestUrl,
    getApiHeaders({ contentType })
  )
);
